export default "__VITE_ASSET__CDM5m7Bc__"